import { useSendCommand } from '@/_core/cqrs/use';
import { Action } from '@/_core/fluxstore/types';
import { ChangeStorymapEstimationUnit } from '../../../api/commands';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class ChangeEstimationUnit extends Action<StorymapState> {
    public static ACTION_TYPE = 'ChangeEstimationUnit';

    public constructor(public estimationUnit: string) {
        super(ChangeEstimationUnit.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: ChangeEstimationUnit): Promise<boolean> => {
    return await useSendCommand(action, {
        createCommand: () => new ChangeStorymapEstimationUnit(state.id, action.estimationUnit)
    });
};

const reducer = (state: StorymapState, action: ChangeEstimationUnit): void => {
    state.estimationUnit = action.estimationUnit;
};

//@ts-ignore
registerMiddleware(ChangeEstimationUnit.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(ChangeEstimationUnit.ACTION_TYPE, reducer);
